export default "__VITE_ASSET__DYmF8rWa__"